<div [ngClass]="{
    'w-100 full-height-mobile position-relative z-max': !viewportService.isLargeViewPort(),
    'h-100': viewportService.isLargeViewPort()}"
    class="d-flex flex-column w-100 overflow-y-auto overflow-x-hidden no-scroll-bar background-white z-max">
    <div class="row position-relative m-0 p-2 background-primary-blue height-70px shadow z-3 d-flex justify-content-center align-items-center">
        <div (click)="back()" class="col-2 pt-4 pb-4 btn text-reset d-flex justify-content-center align-items-center">
            <i class="color-white fa-solid fa-chevron-left fa-xl"></i>
        </div>
        <div class="col-8 row d-flex justify-content-center align-items-center">
          <div class="d-flex justify-content-between align-items-center">
            @if (!loading) {
                <div class="col fs-main text-center color-white">BLE scanners</div>
            }
            <div class="col d-flex">
            <span>
                <app-bluetooth-svg
                  [edgeColor]="'#DFDFDF'"
                    [height]="'20px'"
                    [status]="Status.ONLINE"
                    [width]="'20px'"
                    class="img-fluid img-max m-auto"/>
                </span>
                <span class="color-white p-1">{{ fixedSamplePointsStore.proximitySamplePoints().length }}</span>
            </div>
            <app-action-button
              (click)="downloadPDF()"
              [icon]="'fa-solid fa-download'"
              [disabled]="fixedSamplePointsStore.proximitySamplePoints().length === 0"/>
            </div>
        </div>
        <div (click)="close()" class="pointer text-reset col-2 d-flex justify-content-center align-items-center">
            <i class="color-white fa-solid fa-x fa-xl"></i>
        </div>
    </div>
    <div class="d-flex flex-column p-3 w-100 background-white overflow-y-auto overflow-x-hidden no-scroll-bar">
        <div class="d-flex flex-column gap-3">
            <div class="input-group position-relative">
                <input (input)="filterResults($event.target)"
                        class="form-control m-auto rounded-pill height-50px ps-3 pe-3"
                        placeholder="Search..."
                        style="padding-right: 30px;"
                        type="search">
                <i class="fa-solid fa-magnifying-glass"
                    style="position: absolute; right: 10px; top: 50%; transform: translateY(-50%); pointer-events: none;"></i>
            </div>
            <div>
                @if (filteredUnassignedBluetoothProximitySensors().length !== 0 && filteredProximitySamplePoints().length !== 0) {
                    <div class="fw-bold mb-2">Onboarded scanners</div>
                }
                @for (proximitySamplePoint of filteredProximitySamplePoints(); track proximitySamplePoint.id) {
                    <app-proximity-sample-point-button
                        [id]="proximitySamplePoint.id"/>
                }
            </div>
            @if (filteredUnassignedBluetoothProximitySensors().length !== 0) {
                <div>
                    <div class="fw-bold mb-2">Ready for onboarding</div>
                    @for (device of filteredUnassignedBluetoothProximitySensors(); track device.id) {
                        <app-unassigned-bluetooth-proximity-sensor-button [id]="device.id"/>
                    }
                </div>
            }
        </div>
    </div>
</div>
